import { useState } from 'react'
import { mutate } from 'swr'
import { Upsert_SchoolGroup } from '@graphql/mutations'
import { SchoolGroups_Listing, Single_SchoolGroup } from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useCurrentUser } from '@hooks/useCurrentUser'

const useUpsertSchoolGroup = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { currentUser } = useCurrentUser()
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: data },
      Upsert_SchoolGroup,
      successMessage ? successMessage : 'Grupp skapad.',
      errorMessage ? errorMessage : 'Något gick fel när gruppen skulle sparas.',
      async () => {
        await mutate([SchoolGroups_Listing, currentUser.id])
        await mutate([Single_SchoolGroup, data.id])
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpsertSchoolGroup }
